import { Action } from "redux";
import * as Actions from "../actions/DeployActions";
import * as listActions from "../actions/ProcessListActions";
import { ConfirmDeleteDialogState } from "../model/ConfirmDeleteDialogState";

export function confirmDeleteDialogState(state: ConfirmDeleteDialogState = new ConfirmDeleteDialogState(), action: Action): ConfirmDeleteDialogState {
    switch (action.type) {
        case listActions.CLOSE_CONFIRM_DELETE_DIALOG: {
            return new ConfirmDeleteDialogState();
        }
        case listActions.OPEN_CONFIRM_DELETE_DIALOG: {
            const openConfirmDialogAction = action as listActions.IOpenConfirmDeleteDialogAction;
            return openConfirmDialogAction.dialogState;
        }
        default:
            return state;
    }
}
